import { TFunction } from 'react-i18next'

import { YearFilterError, YearFilterValue } from './Types'

export const YearOfBirthFilterOptions = [
  'Equals',
  'Is before',
  'Is after',
  'Is between',
]

interface FilterValues {
  displayName: string
  year: number
}

export const initialYearFilterValue = (value: FilterValues[]) => {
  return {
    to: 0,
    from: 0,
    year: 0,
    label: 'is_between',
    values: value?.length ? value : [],
  }
}

export const initialYearFilterError = {
  label: '',
  state: false,
  to_error: '',
  from_error: '',
  year_error: '',
}

export const acceptableYearOptions = (year: number) => {
  const numberString = `${year}`
  // Use a regular expression to check for a four-digit number in the range 1000-9999
  const pattern = /\b\d{4}\b/
  return pattern.test(numberString)
}

export const yearFromIsGreaterThanYearTo = (from: number, to: number) => {
  return from > to
}

export const generateHelperText = (
  yearFilterError: YearFilterError,
  yearFilterValue: YearFilterValue,
  t: TFunction,
) => {
  const newObj = { ...yearFilterError, ...{ label: yearFilterValue.label } }

  if (
    yearFilterValue.label !== 'is_between' &&
    !acceptableYearOptions(yearFilterValue.year)
  ) {
    newObj.state = true
    newObj.year_error = t('filters.yob.errorMessage.valid_year')
  } else if (yearFilterValue.label === 'is_between') {
    newObj.from_error = !acceptableYearOptions(yearFilterValue.from)
      ? t('filters.yob.errorMessage.valid_year')
      : ''

    !acceptableYearOptions(yearFilterValue.to)
      ? (newObj.to_error = t('filters.yob.errorMessage.valid_year'))
      : yearFromIsGreaterThanYearTo(yearFilterValue.from, yearFilterValue.to) &&
        (newObj.to_error = t('filters.yob.errorMessage.from_lesser_than_to'))

    newObj.state =
      newObj.from_error !== '' || newObj.to_error !== '' ? true : false
  }

  return newObj
}

export const generateDisplayNameandValues = (
  yearFilterValue: YearFilterValue,
  t: TFunction,
) => {
  const returnedObj = { ...yearFilterValue }
  if (yearFilterValue.label == 'equals') {
    returnedObj.values = [
      {
        year: yearFilterValue.year,
        displayName: t('filters.yob.displayName.equals', {
          year: yearFilterValue.year,
        }),
      },
    ]
  } else if (yearFilterValue.label == 'is_between') {
    returnedObj.values = []
    let k: number = yearFilterValue.from
    while (k <= yearFilterValue.to) {
      returnedObj.values.push({
        year: k,
        displayName: t('filters.yob.displayName.is_between', {
          from: yearFilterValue.from,
          to: yearFilterValue.to,
        }),
      })
      k++
    }
  } else if (yearFilterValue.label == 'is_after') {
    returnedObj.values = []
    let k: number =
      yearFilterValue.year < 1900 ? 1900 : yearFilterValue.year + 1
    const currentYear = new Date().getFullYear()
    if (k > currentYear) {
      returnedObj.values = [
        {
          year: k,
          displayName: t('filters.yob.displayName.is_after', {
            year: yearFilterValue.year,
          }),
        },
      ]
    }
    while (k <= currentYear) {
      returnedObj.values.push({
        year: k,
        displayName: t('filters.yob.displayName.is_after', {
          year: yearFilterValue.year,
        }),
      })
      k++
    }
  } else if (yearFilterValue.label == 'is_before') {
    returnedObj.values = []
    const startYear = 1899
    const endYear =
      yearFilterValue.year > 1900 ? yearFilterValue.year - 1 : startYear

    for (let i = startYear; i <= endYear; i++) {
      returnedObj.values.push({
        year: i,
        displayName: t('filters.yob.displayName.is_before', {
          year: yearFilterValue.year,
        }),
      })
    }
  }

  return returnedObj
}
